import PropTypes from 'prop-types';

const SiteSpinner = ({
  backgroundColor = 'var(--brand_primary)',
  border,
  height = '40px',
  width = '40px',
  padding,
  styles,
}) => {
  return (
    <div
      className="site-spinner"
      style={{
        backgroundColor,
        width,
        height,
        padding,
        border,
        ...styles,
      }}
    ></div>
  );
};

SiteSpinner.propTypes = {
  backgroundColor: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  padding: PropTypes.string,
  border: PropTypes.string,
  styles: PropTypes.object,
};

export default SiteSpinner;
